import { Injectable, OnInit, OnDestroy } from "@angular/core";
import { HttpClient, HttpParams, HttpErrorResponse, HttpResponse } from "@angular/common/http";

import { MongoCursorModel } from "../models/mongoCursor.model";
import { MongoImageModel } from "../models/mongoImage.model";
import { AuthenticationServices } from "./authentication.services";
import { AppAlertsServices } from "./app-alerts.services";
import { AutoFillServices } from "./autofill.services";

import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/retry';
import 'rxjs/add/observable/of';

@Injectable()

export class MongoImageServices implements OnInit, OnDestroy {
  private assets: any[] = new Array();
  private baseUrl = '/api';

  private latestParams: any = { view: undefined, search: undefined };
  latestSearch: any;

  private viewSubject = new BehaviorSubject({images: this.assets, isSearch: false});
  onUpdatedView = this.viewSubject.asObservable();

  private searchTermsSubject = new BehaviorSubject({ terms: undefined, isSearch: false });
  onUpdatedSearchTerms = this.searchTermsSubject.asObservable();
  public total: number = 0;

  private tabsSubject = new BehaviorSubject(null);
  onUpdatedTabs = this.tabsSubject.asObservable();

  private searchTabsSubject = new BehaviorSubject(null);
  onUpdatedSearchTabs = this.searchTabsSubject.asObservable();

  private paginationSubject = new BehaviorSubject(null);
  onUpdatedPagination = this.paginationSubject.asObservable();

  private setCursorParams = ( cursor: any ): HttpParams => {
    const { method, page, month, year, isSearch, tabs } = cursor;
    let params = new HttpParams();
    let keys = Object.keys( cursor );
    keys.forEach( key => {
      const isObj = (typeof cursor[key] === 'object' && !Array.isArray( cursor[key]));
      let thisValue;
      if ( isObj ) {
        const { value } = cursor[key];
        thisValue = value;
      } else {
        thisValue = cursor[key];
      }
      params = params.set( key , thisValue );
    });

    if ( method !== 'tabs' && method !=='delete') {
      isSearch ? this.latestParams.search = params : this.latestParams.view = params;
    }
    return params;

  }

  constructor(
    private http: HttpClient,
    private activeUser: AuthenticationServices,
    private message: AppAlertsServices,
    private fill: AutoFillServices,
  ) {
    this.getSearchTerms();
  }

  ngOnInit(): void {}
  ngOnDestroy(): void {}

  getSearchTerms( cursor?: any ): Observable<any> {
    if ( this.activeUser.isAdmin || this.activeUser.isPermitted['to_view_images'] ) {
      let method: string, isSearch: boolean;
      if (cursor) method = cursor.method, isSearch = cursor.isSearch;
      let params = cursor? this.setCursorParams( this.latestSearch ) : null;
      params = params? params.set('method', method) : null;

      try {
        const response = this.http.get( `${this.baseUrl}/searchTerms/Photos`, { params: params, observe: 'body'} )
        const searchTerms = response.pluck( 'body' );

        searchTerms.subscribe(
          ( result: any ) => {
            this.searchTermsSubject.next( { terms: result , isSearch: isSearch} );
          },
          ( error: HttpErrorResponse ) => {
            this.message.set( error );
            throw error;
          }
        );
        return searchTerms;
      }
      catch ( error ) { this.message.set( error )}
      finally {}

    } else {
      let message = new HttpErrorResponse({
        error: { name: 'Get Search Terms'},
        status: 403,
        statusText: 'Forbidden'
      })
      this.message.set( message )
    }
  }

  getTabs(tab?: any): Observable<any> {
    if ( this.activeUser.isAdmin || this.activeUser.isPermitted['to_view_images'] ) {
      const { isSearch } = tab ? tab : undefined;
      let params = isSearch ? this.setCursorParams(this.latestSearch) : this.setCursorParams( tab );
      params = params.set('method', 'tabs');

      if ( isSearch ) {
        Object.keys(tab).forEach((key:string) => {
          params = params.set(key, tab[key]);
        });
      }

      try {
        const tabs = this.http.get( `${this.baseUrl}/generate_tabs/Photos`, { params : params , observe : 'body' } )
        const body = tabs.pluck( 'body' );

        tabs
          .map( ( response:any )  => new HttpResponse( response ) )
          .subscribe(
            (response : any) => {
              const { body, url } = response;
              if ( !body && url ) {
                const statusText = url === "year" ? `Collection empty: ${url}` : `Tabs empty: ${url}`;
                let message = new HttpErrorResponse({
                  error: { name: 'Get Tabs'},
                  status: 10000,
                  statusText: statusText
                })
                this.message.set(message);
              }
              else if ( !isSearch ) {
                let tabs = ( url === 'year' ) ? body.reverse(): body;
                this.tabsSubject.next({ tabs: tabs, type: url });
              }
              else {
                this.searchTabsSubject.next({ tabs: body, type: url });
              }
             },
            (error : HttpErrorResponse) => {
              console.log('error: ', error)
              this.message.set( error );
              throw error;
            })


        return body;
      }
      catch ( error ) { this.message.set( error )}
      finally {}

    } else {
      let message = new HttpErrorResponse({
        error: { name: 'Get Tabs'},
        status: 403,
        statusText: 'Forbidden'
      })
      this.message.set();
    }

  }

  getView( cursor?: MongoCursorModel, reset?: any ): void {
    if( this.activeUser.isAdmin || this.activeUser.isPermitted['to_view_images'] ) {
      let params = cursor ? this.setCursorParams( cursor ) : this.latestParams.view;
      reset ? this.latestSearch = new MongoCursorModel('search') : null ;

      try {
        const response = this.http.get( `${this.baseUrl}/Search/Photos`, { params: params, observe: 'body' } )
        const images = response.pluck( 'body' );

          images
            .subscribe(
              ( images : any ) => {
                let { docs, page, pages, total } = images;
                if ( docs.length > 0 ) {
                  this.assets = images;
                  this.viewSubject.next({ images: images, isSearch: false });
                  this.paginationSubject.next({ page: page, pages: pages });
                  if ( !cursor || reset ) this.getSearchTerms();
                }
                else if ( page > pages ) {
                  this.latestParams.view = this.latestParams.view.set('page', pages);
                  this.getView();
                }
                else {
                  const year = parseInt( this.latestParams.view.get('year'));
                  this.getTabs( year );
                  this.getSearchTerms();
                }

              },
              ( error : HttpErrorResponse) => {
                this.message.set( error );
                throw error
              })

          response
            .map( ( result:any ) => new HttpResponse( result ) )
            .subscribe(
              ( result : any ) => {
                const { docs, pages, page, total } = result.body;
                if( docs.length === 0 ) {
                  this.message.set( result );
                }
              },
              ( error : HttpErrorResponse ) => {
                this.message.set( error );
                throw error
              }
            )
      }
      catch ( error ) { this.message.set( error ) }
      finally {}

    } else {
      let message = new HttpErrorResponse({
        error: { name: 'Get View'},
        status: 403,
        statusText: 'Forbidden'
      })
      this.message.set( message );
    }
  }

  search( cursor?: MongoCursorModel ) : Observable<any> {
    if ( this.activeUser.isAdmin || this.activeUser.isPermitted[ 'to_view_images' ] ) {

      let cursorParams = cursor ? this.setCursorParams( cursor ) : this.latestParams.search;
      cursor ? this.latestSearch = cursor: null;

      try {
        const response = this.http.get( `${this.baseUrl}/Search/Photos`, { params: cursorParams , observe: 'body' } )
        const searchResult = response.pluck( 'body' );

        searchResult.subscribe(
          ( images : any ) => {
            const { docs, pages, page, total } = images;
            if ( docs.length > 0 ) {
              this.assets = images;
              this.viewSubject.next( { images: images, isSearch: true })
              this.paginationSubject.next({ page: page, pages: pages });
              if (!cursor || cursor.get('page') === 1) this.getSearchTerms({ method: 'search', isSearch: true })
            }
            else if( page > pages) {
              this.latestParams.search = this.latestParams.search.set( 'page', pages);
              this.search();
            }
            else {
              this.latestSearch = new MongoCursorModel("search");
              this.getView();
            }
          },
          ( error : HttpErrorResponse ) => {
            this.message.set( error );
            throw error;
          }
        )

        return searchResult;
      }
      catch ( error ) {}
      finally {}

    } else {
      let message = new HttpErrorResponse( {
        error: { name: 'Search Images'},
        status: 403,
        statusText: 'Forbidden'
      } )
      this.message.set( message );
    }
  }


  update( model?: MongoCursorModel): void {
    if ( this.activeUser.isAdmin || this.activeUser.isPermitted['to_edit_images'] ) {
      const isSearch = model.get('isSearch');
      try {
        this.http.post( `${this.baseUrl}/Update/Photos`, model, { observe: 'body' } )
          .map( ( result: any ) => new HttpResponse( result ) )
          .subscribe(
            ( result : any ) => {
              this.message.set( result );
              isSearch ? this.search() : this.getView();
              this.fill.getAutoFillTerms();
            },
            ( error : HttpErrorResponse ) => {
              this.message.set( error );
              throw error;
            })
      }
      catch (error) {}
      finally {}

    } else {
     let message = new HttpErrorResponse({
        error: { name: 'Update Images'},
        status: 403,
        statusText: 'Forbidden'
      })
      this.message.set( message )
    }
  }

  reset( resetObject: any ) : void {
    if ( this.activeUser.isAdmin || this.activeUser.isPermitted['to_delete_images'] ) {
      const isSearch = resetObject.get('isSearch');
      try {
        this.http.post( `${this.baseUrl}/Reset/Photos`, resetObject )
          .map( ( result: any ) => new HttpResponse( result ) )
          .subscribe(
            ( result: any) => {
              this.message.set( result );
              isSearch ? this.search() : this.getView();
              this.fill.getAutoFillTerms();
            },
            ( error: HttpErrorResponse ) => {
              this.message.set( error );
            }
          )
      }
      catch ( error ) { this.message.set( error ) }
      finally {}

    } else {
      let message = new HttpErrorResponse({
        error: { name: 'Reset Image Meta'},
        status: 403,
        statusText: 'Forbidden'
      })
      this.message.set( message );
    }
  }

  delete( model?: MongoCursorModel ): void {
    if(this.activeUser.isAdmin || this.activeUser.isPermitted['to_delete_images']) {
      const isSearch = model.get('isSearch');
      let params = new HttpParams();
      params = this.setCursorParams( model );
      let options = {
        params : params,
      };

      try {
        this.http.delete(`${this.baseUrl}/:_id/Photos`, options)
          .map( ( result: any ) => new HttpResponse( result ) )
          .subscribe(
            ( result: any ) => {
              this.message.set( result )
              isSearch ? this.search() : this.getView();
              this.fill.getAutoFillTerms();
            },
            (error: HttpErrorResponse) => {
              this.message.set(error);
            }
          )
      }
      catch(error) { this.message.set( error ) }
      finally {}

    } else {
      let message = new HttpErrorResponse({
        error: { name: 'Delete Images' },
        status: 403,
        statusText: 'Forbidden'
      })
      this.message.set( message )
    }
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/services/mongoImage.services.ts